import store from "./../store/store.js";
import { MySpeechEvent } from "./MySpeechEvent.js";

class MySpeechRecognition {


    constructor(language) {
        // Instance Variables
        this.language = language;
        this.runtimeTranscription = '';
        this.transcription = [];
        this.recognitionInstance;

        window.SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition

      
        if (!window.SpeechRecognition) {
            console.log(' ----- SEVERE: NO INIT OF SPEECH ------')
            let mySpeechEvent = new MySpeechEvent('nospeech', new Date().getTime(), '', '');
            store.commit('setVoiceEvent', mySpeechEvent);
            return
        }


        let recognition = new window.SpeechRecognition()

        recognition.lang = "de-de"
        recognition.interimResults = true

      

        recognition.onaudiostart = () => {
            console.log("SpeechEvent : onaudiostart");
            let mySpeechEvent = new MySpeechEvent('onaudiostart', new Date().getTime(), '', []);
            store.commit('setVoiceEvent', mySpeechEvent);
        };

        recognition.onboundary = function () {
            console.log("SpeechEvent : onboundary");
            let mySpeechEvent = new MySpeechEvent('onboundary', new Date().getTime(), '', []);
            store.commit('setVoiceEvent', mySpeechEvent);
        };

        recognition.onspeechstart = function () {
            console.log("SpeechEvent : onspeechstart");
            let mySpeechEvent = new MySpeechEvent('onspeechstart', new Date().getTime(), '', []);
            store.commit('setVoiceEvent', mySpeechEvent);
        };

        recognition.onspeechend = function () {
            console.log("SpeechEvent : onspeechend");
            let mySpeechEvent = new MySpeechEvent('onspeechend', new Date().getTime(), '', []);
            store.commit('setVoiceEvent', mySpeechEvent);
        };

        recognition.onsoundend = function () {
            console.log("SpeechEvent : onsoundend");
            let mySpeechEvent = new MySpeechEvent('onsoundend', new Date().getTime(), '', []);
            store.commit('setVoiceEvent', mySpeechEvent);
        };

        recognition.onaudioend = function () {
            console.log("SpeechEvent : onaudioend");
            let mySpeechEvent = new MySpeechEvent('onaudioend', new Date().getTime(), '', []);
            store.commit('setVoiceEvent', mySpeechEvent);
        };


        recognition.onerror = function (event) {
            console.log(">>>>>>>>>>>> SpeechEvent : onerror" + JSON.stringify(event));
            let mySpeechEvent = new MySpeechEvent('onerror', new Date().getTime(), '', []);
            store.commit('setVoiceEvent', mySpeechEvent);
        };

        recognition.addEventListener('result', event => {
            const text = event.results[0][0].transcript;          
            this.runtimeTranscription = text;
            let mySpeechEvent = new MySpeechEvent('result', new Date().getTime(), text, []);
            store.commit('setVoiceEvent', mySpeechEvent);
        })


        recognition.onend = (event) => {
            if (this.runtimeTranscription !== '') {

                console.log("SpeechEvent : onend" + " > " + JSON.stringify(event));               
                let mySpeechEvent = new MySpeechEvent('onend', new Date().getTime(), this.runtimeTranscription, []);
                store.commit('setVoiceEvent', mySpeechEvent);

            }
            else {

                console.log("SpeechEvent : onend (no transcription detected)"); 
                let mySpeechEvent = new MySpeechEvent('onend', new Date().getTime(), '', []);
                store.commit('setVoiceEvent', mySpeechEvent);

            }


          
  
        };

        this.recognitionInstance = recognition;

        this.runtimeTranscription = ''
    }

    start() {
        this.runtimeTranscription = "";
        this.recognitionInstance.start();
    }

    stop() {
   
        this.recognitionInstance.stop();
    }

}

export { MySpeechRecognition }

